import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AdminUsersService } from '../../admin-users/services/admin-users.service';
import { AuthService } from '../services/auth.service';
import { LoginData } from '../user-login';
const alertify = require("alertify.js");

@Component({
  selector: 'ch-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  private INVALID_TOTP_ERROR = 'mfa_required';

  public loading: boolean;
  public loginData: LoginData = {
    username: '',
    password: '',
    totp: null
  };
  public showTotp: boolean;

  constructor(private authService: AuthService, private adminUsersService: AdminUsersService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    alertify.logPosition("bottom right");
  }

  public login(form) {
    if (!form.valid) {
      for (const i in form.controls) {
        form.controls[i].markAsTouched();
      }

      return;
    }

    this.loading = true;
    this.authService
      .login(this.loginData)
      .then(() => {
        this.loading = false;
        this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl || '/admin/dashboard');
      })
      .catch((res) => {
        const reason = res.json().error;
        if (reason === this.INVALID_TOTP_ERROR) {
          if (this.showTotp) {
            alertify.error('Invalid TOTP')
          } else {
            this.showTotp = true;
          }
        } else {
          alertify.error('Invalid credentials')
        }

        this.loading = false;
      });
  }

  public forgottenPassword() {
    this.router.navigateByUrl('forgotten-password');

    return false;
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/auth/login/login.component.ts